import {SimpleMenu} from "@mediaspace/shared/ui";
import {useState} from "react";
import {translate, useMediaQuery} from "@mediaspace/shared/utils";
import {KmsTypeAction} from "@mediaspace/shared/types";
import {Button, Modal} from "@kaltura/ds-react-components";
import {MoreVertical24Icon} from "@kaltura/ds-react-icons";
import {componentsMap} from "./componentsMap";
import ActionsItem from "./actions-item/ActionsItem";
import {useButtonAnalytics} from "@mediaspace/hooks";
import {ButtonClickAnalyticsType} from "@mediaspace/shared/types/ButtonClickAnalyticsType";
import {useTheme} from "@mediaspace/shared/styled";

export interface ActionsMenuProps {
    actions: KmsTypeAction[];
    onShowNotification: (message: string, severity: "success" | "error") => void;
}

export type ActionProps = {
    componentName: string;
    [key: string]: string | number
}

// dynamically render component by its name
const renderComponent = (componentData, onClose, onShowNotification) => {
    const Component = componentsMap[componentData.componentName];
    const {componentName, ...props} = componentData;
    return <Component {...props} onModalClose={onClose} onShowNotification={onShowNotification}/>;
}

/**
 * channel actions menu
 */
const ActionsMenu = (props: ActionsMenuProps) => {

    const {actions, onShowNotification} = props;

    const [currentModalComponent, setCurrentModalComponent] = useState<ActionProps>();
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [closeMenu, setCloseMenu] = useState<boolean>(false);

    const populateModal = (data: ActionProps) => {
        setCurrentModalComponent(data);
        setIsOpen(true);
        setCloseMenu(true);
    }

    const onClose = () => {
        setIsOpen(false);
    }

    const sendButtonAnalytics = useButtonAnalytics();
    const theme = useTheme();
    const isXsScreenOrBellow = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.xs));

    if (actions.length === 0) {
        return null;
    }

    return (
        <>
            <SimpleMenu
                id={"channelActions"}
                button={
                    <Button
                        variant={"borderless"}
                        startIcon={<MoreVertical24Icon />}
                        value={translate("Actions")}
                    >
                        {isXsScreenOrBellow? "" : translate("Actions")
                    }</Button>
                }
                className={"kms-ds-channel-page-actions-menu-button"}
                close={closeMenu}
                onOpen={() => {
                    sendButtonAnalytics("Actions", ButtonClickAnalyticsType.MENU);
                    setCloseMenu(false)
                }}
            >
                {actions.map((item, index) =>
                    <ActionsItem
                        key={`channel-action-${index}`}
                        itemProps={{ ...item, autoFocus: index === 0 }}
                        populateModal={populateModal}
                    />
                )}
            </SimpleMenu>

            {/* modal for dynamic actions which are more than a simple redirect */}
            {currentModalComponent &&
                <Modal open={isOpen}>
                    {renderComponent(currentModalComponent, onClose, onShowNotification)}
                </Modal>
            }
        </>
    );
};

export default ActionsMenu;
